module.exports = __webpack_public_path__ + "static/media/whip.a8a3233c.mp3";